import getToken from "../../utils/getToken"
import { API } from "../../config/api"

export default async (id) => {
    try{
        const token = getToken()

        const response = await fetch(`${API}/tickets/${id}`,{
            method:'DELETE',
            headers:{
                'Authorization': `Bearer ${token}`
            },
        })

        const {success,ticket} = await response.json()

        return {success,ticket}
    }catch(error){
        console.log(error)

        return {success:false}
    }
}